import { DecorItemI, OriginDecorI } from "../../../shared";
import { generateID } from "../../helpers/generateID";
import convertDegreesToRadians from "../../../utils/convertDegreesToRadians";
import { SideType } from "../../types/store";
import { useStoreRoom } from "../../useStoreRoom";
import { Euler } from "three/src/math/Euler";
import { Vector3 } from "three";

export const addDecor = (originDecor: OriginDecorI, currentSide: SideType) => {
    const decors: DecorItemI[] = [...useStoreRoom.getState().decors];
    const roomLength = useStoreRoom.getState().length;
    const roomDepth = useStoreRoom.getState().depth;
    const roomHeight = useStoreRoom.getState().height;

    const decor: DecorItemI = {
        id: generateID(),
        initialized: false,
        code: originDecor.CODE,
        bitrixId: originDecor.ID,
        type: originDecor.TYPE_MODEL.CODE,
        name: originDecor.NAME,
        model: originDecor.PROPERTIES.FILE_3D,
        modelId: originDecor.ID,
        surface: originDecor.TYPE_POSITION,
        position: [0, 0, 0],
        center: [0.5, 0.5, 0.5],
        translate: [0, 0, 0],
        rotation: new Vector3(0, 0, 0),
        width: 0,
        height: 0,
        depth: 0,
        side: "front",
    };

    if (currentSide === "left") {
        decor.side = "left";
        decor.position[0] = -roomLength / 2000 + decor.width;
        decor.position[2] = roomDepth / 2000;
        decor.rotation = new Vector3(0, convertDegreesToRadians(90), 0);
    }
    if (currentSide === "right") {
        decor.side = "right";
        decor.position[0] = roomLength / 2000 - decor.width;
        decor.position[2] = roomDepth / 2000;
        decor.rotation = new Vector3(0, convertDegreesToRadians(270), 0);
    }

    if (currentSide === "back") {
        decor.side = "back";
        decor.position[0] = 0;
        decor.position[2] = roomDepth / 1000;
        decor.rotation = new Vector3(0, convertDegreesToRadians(180), 0);
    }

    if (decor.surface === "floor") {
        decor.position[0] = 0;
        decor.position[2] = roomDepth / 2000 - decor.width / 2;
    }

    if (decor.surface === "ceiling") {
        decor.position[0] = 0;
        decor.position[2] = roomDepth / 2000 - decor.width / 2;
    }

    if (decor.type !== "doors" && decor.surface === "wall") {
        decor.position[1] = roomHeight / 2000 - decor.height / 2;
    }
    decors.push(decor);
    return decors;
};
